import { render, staticRenderFns } from "./InstrumentPerformanceView.vue?vue&type=template&id=1c968ac4&scoped=true"
import script from "./InstrumentPerformanceView.vue?vue&type=script&lang=ts"
export * from "./InstrumentPerformanceView.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentPerformanceView.vue?vue&type=style&index=0&id=1c968ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c968ac4",
  null
  
)

export default component.exports